import ch from '../assets/images/flags/China.png';
import en from '../assets/images/flags/United States.png';
import German from '../assets/images/flags/Germany.png';
import Japan from '../assets/images/flags/Japan.png';
import Sk from '../assets/images/flags/South Korea.png';
import Fran from '../assets/images/flags/France.png';
import Russia from '../assets/images/flags/Russia.png';
import Spain from '../assets/images/flags/Spain.png';
import Portugal from '../assets/images/flags/Portugal.png';
import Italy from '../assets/images/flags/Italy.png';
import VietNam from '../assets/images/flags/Vietnam.png';
import Arab from '../assets/images/flags/Saudi Arabia.png';
const  options  =   [{
    value: 'cn',
    label: '中文简体',
    flag: ch,
  }, {
    value: 'en',
    label: 'English',
    flag: en,
  }/*, {
    value: 'dy',
    label: 'Deutsch',
    flag: German,
  }, {
    value: 'ry',
    label: '日本語',
    flag: Japan,
  }, {
    value: 'hy',
    label: '한국어',
    flag: Sk,
  }, {
    value: 'fy',
    label: 'En français',
    flag: Fran,
  }, {
    value: 'ey',
    label: 'русск',
    flag: Russia,
  }, {
    value: 'xby',
    label: 'español',
    flag: Spain,
  }, {
    value: 'ptyy',
    label: 'português',
    flag: Portugal,
  }, {
    value: 'ydly',
    label: 'Italiano',
    flag: Italy,
  }, {
    value: 'yny',
    label: 'Việt nam',
    flag: VietNam
  }, {
    value: 'alby',
    label: 'العربية',
    flag: Arab
  }*/
];


export default options;



// WEBPACK FOOTER //
// ./src/config/support.langs.js